



























import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
} from '@vue/composition-api'
import Twitch from '@/components/Twitch.vue'
import { setScoreListener } from '@/firebase/index'

export default defineComponent({
  components: {
    Twitch,
  },
  setup(_, context) {
    const state = reactive<{ channel: string; autoplay: boolean }>({
      channel: 'focuson_dj',
      autoplay: false,
    })

    const backgroundLength = ref(100)
    const gauge = ref<HTMLDivElement>()
    const resizeHandler = () => {
      if (!gauge) return
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      const width: number = gauge.value?.clientWidth!
      backgroundLength.value = width
    }

    const submit = async () => {
      const res = await fetch('https://asia-northeast1-project-fo.cloudfunctions.net/v1/counter', {
        method: 'POST',
      })
      console.log('submit', res)
    }

    const dynamicCssVariables = computed(() => {
      return {
        '--background-length': `${backgroundLength.value}px`,
      }
    })

    // 生のスコア
    const score = ref(0)

    const normalizedScore = computed(() => {
      // 正規化するならここ
      let val = score.value / 100
      if (val < 0.05) val = 0.05
      return val
    })
    // 閾値
    const THRESHOLD = [0, 0.5, 1]

    const backgroundClassObj = computed(() => {
      const idx = THRESHOLD.reduce((acc: number, thre: number, index: number) => {
        if (normalizedScore.value >= thre) return index
        else return acc
      }, 0)
      return { [`background-level${idx + 1}`]: true }
    })

    const foregroundWidthStyle = computed(() => {
      const magnification = normalizedScore.value > 1 ? 1 : normalizedScore.value
      return { width: `${magnification * backgroundLength.value}px` }
    })

    const mobile = computed(() => {
      return context.root.$vuetify.breakpoint.mobile
    })

    onMounted(() => {
      window.addEventListener('resize', resizeHandler)
      context.root.$nextTick(() => {
        resizeHandler()
      })
      window.addEventListener('keyup', (e: KeyboardEvent) => {
        // @MEMO: 押しっぱなしにすると連続入力できてしまうし、PCそんなに必要ないから保留
        // if (e.code === 'Space') submit()
      })

      setScoreListener((_score: any) => {
        score.value = _score
      })

      // デバグ用関数
      window.addEventListener('keydown', (e: KeyboardEvent) => {
        const pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/
        if (pattern.test(e.key)) {
          const num = Number(e.key)
          if (num === 0) {
            score.value = 100
          } else {
            score.value = num * 10
          }
        }
      })
    })
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      ...toRefs(state),
      dynamicCssVariables,
      gauge,
      backgroundClassObj,
      foregroundWidthStyle,
      score,
      mobile,
      submit,
    }
  },
})
